"use client";

import React from 'react';
import Link from 'next/link';
import { ArrowLeft, Book, Sword } from 'lucide-react';
import { AboutLayout } from '@/components/about/about-layout';

const swordsCards = [
  { name: "Ace of Swords", slug: "ace-of-swords", turkish: "Kılıçlar Ası", keyword: "Zihinsel berraklık", image: "ace-of-swords.svg" },
  { name: "Two of Swords", slug: "two-of-swords", turkish: "İki Kılıç", keyword: "Kararsızlık ve denge", image: "two-of-swords.svg" },
  { name: "Three of Swords", slug: "three-of-swords", turkish: "Üç Kılıç", keyword: "Kalp kırıklığı", image: "three-of-swords.svg" },
  { name: "Four of Swords", slug: "four-of-swords", turkish: "Dört Kılıç", keyword: "Dinlenme ve meditasyon", image: "four-of-swords.svg" },
  { name: "Five of Swords", slug: "five-of-swords", turkish: "Beş Kılıç", keyword: "Çatışma ve yenilgi", image: "five-of-swords.svg" },
  { name: "Six of Swords", slug: "six-of-swords", turkish: "Altı Kılıç", keyword: "Geçiş ve seyahat", image: "six-of-swords.svg" },
  { name: "Seven of Swords", slug: "seven-of-swords", turkish: "Yedi Kılıç", keyword: "Strateji ve aldatma", image: "seven-of-swords.svg" },
  { name: "Eight of Swords", slug: "eight-of-swords", turkish: "Sekiz Kılıç", keyword: "Kısıtlama ve esaret", image: "eight-of-swords.svg" },
  { name: "Nine of Swords", slug: "nine-of-swords", turkish: "Dokuz Kılıç", keyword: "Endişe ve kabus", image: "nine-of-swords.svg" },
  { name: "Ten of Swords", slug: "ten-of-swords", turkish: "On Kılıç", keyword: "Son ve yeniden başlangıç", image: "ten-of-swords.svg" },
  { name: "Page of Swords", slug: "page-of-swords", turkish: "Kılıçlar Prensi", keyword: "Merak ve araştırma", image: "page-of-swords.svg" },
  { name: "Knight of Swords", slug: "knight-of-swords", turkish: "Kılıçlar Şövalyesi", keyword: "Hızlı eylem", image: "knight-of-swords.svg" },
  { name: "Queen of Swords", slug: "queen-of-swords", turkish: "Kılıçlar Kraliçesi", keyword: "Keskin zeka", image: "queen-of-swords.svg" },
  { name: "King of Swords", slug: "king-of-swords", turkish: "Kılıçlar Kralı", keyword: "Zihinsel otorite", image: "king-of-swords.svg" }
];

export default function SwordsSuitPage() {
  return (
    <AboutLayout activeSection="tarot">
      <div className="max-w-6xl mx-auto px-4 py-8">
        {/* Current Section Indicator */}
        <div className="mb-4 p-3 bg-gray-500/10 border border-gray-500/20 rounded-lg">
          <div className="flex items-center gap-2 text-gray-300">
            <Book className="h-4 w-4" />
            <span className="text-sm font-medium">🃏 Tarot</span>
            <span className="text-gray-500">/</span>
            <span className="text-sm">Rider-Waite</span>
            <span className="text-gray-500">/</span>
            <span className="text-sm">Minör Arkana</span>
            <span className="text-gray-500">/</span>
            <span className="text-sm">Kılıçlar</span>
          </div>
        </div>

        {/* Breadcrumb */}
        <div className="mb-6">
          <Link
            href="/about"
            className="inline-flex items-center text-slate-400 hover:text-slate-200 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            AXTROLOG Nedir
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Tarot Sistemleri
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems/rider-waite"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Rider-Waite
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <Link
            href="/about/tarot/systems/rider-waite/minor-arcana"
            className="text-slate-400 hover:text-slate-200 transition-colors"
          >
            Minör Arkana
          </Link>
          <span className="text-slate-500 mx-2">/</span>
          <span className="text-slate-300">Kılıçlar</span>
        </div>

        {/* Header */}
        <div className="bg-gradient-to-r from-gray-900/20 to-slate-900/20 rounded-xl p-8 mb-8 border border-gray-500/20">
          <h1 className="text-4xl font-bold text-slate-100 mb-4 flex items-center gap-3">
            <Sword className="h-10 w-10 text-gray-400" />
            Kılıçlar (Swords) Suit'i
          </h1>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div>
              <p className="text-lg text-slate-200 leading-relaxed mb-4">
                Hava elementi ile ilişkilendirilen Kılıçlar suit'i, düşünce, mantık, çatışma ve
                zihinsel güç alanlarını temsil eder. İletişim, adalet ve entelektüel meydan okumalar konularında rehberlik sunar.
              </p>
              <div className="flex flex-wrap gap-2">
                <span className="px-3 py-1 bg-gray-500/20 text-gray-300 rounded-full text-sm">Hava Elementi</span>
                <span className="px-3 py-1 bg-gray-500/20 text-gray-300 rounded-full text-sm">Düşünce</span>
                <span className="px-3 py-1 bg-gray-500/20 text-gray-300 rounded-full text-sm">Mantık</span>
                <span className="px-3 py-1 bg-gray-500/20 text-gray-300 rounded-full text-sm">İletişim</span>
              </div>
            </div>
            <div className="bg-slate-800/50 rounded-lg p-6 border border-gray-500/30">
              <h3 className="text-lg font-semibold text-slate-100 mb-3">Temel Özellikler</h3>
              <ul className="space-y-2 text-slate-300 text-sm">
                <li>• <strong>Element:</strong> Hava</li>
                <li>• <strong>Kişilik:</strong> Sanguine (Sıcak ve Nemli)</li>
                <li>• <strong>Astrolojik İlişki:</strong> İkizler, Terazi, Kova</li>
                <li>• <strong>Yaşam Alanı:</strong> Zihin, iletişim, çatışma çözümü</li>
                <li>• <strong>Anahtar Kelimeler:</strong> Analiz, netlik, adalet</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mb-8">
          {swordsCards.map((card, index) => (
            <Link
              key={card.slug}
              href={`/about/tarot/systems/rider-waite/minor-arcana/swords/${card.slug}`}
              className="block"
            >
              <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 hover:border-gray-500/50 transition-all duration-300 cursor-pointer group shadow-lg hover:shadow-xl hover:scale-[1.02] h-full">
                <div className="text-center">
                  <div className="w-24 h-36 mx-auto mb-4 rounded-lg overflow-hidden group-hover:scale-105 transition-transform duration-300 shadow-lg">
                    <img
                      src={`/images/tarot/cards/${card.image}`}
                      alt={card.name}
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        // Fallback to numbered circle if image fails to load
                        e.currentTarget.style.display = 'none';
                        const sibling = e.currentTarget.nextElementSibling as HTMLElement;
        if (sibling) {
          sibling.style.display = 'flex';
        }
                      }}
                    />
                    <div className="w-full h-full bg-gradient-to-br from-gray-500 to-slate-700 rounded-lg flex items-center justify-center" style={{display: 'none'}}>
                      <span className="text-white font-bold text-lg">{index + 1}</span>
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-slate-100 mb-2">{card.name}</h3>
                  <p className="text-slate-400 text-sm mb-3">{card.turkish}</p>
                  <p className="text-gray-400 text-sm font-medium">{card.keyword}</p>
                </div>
                <div className="mt-4 pt-4 border-t border-slate-700">
                  <span className="text-gray-400 text-sm group-hover:translate-x-1 transition-transform duration-300 inline-block">
                    Kartı İncele →
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Suit Information */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
            <h2 className="text-2xl font-semibold text-slate-100 mb-4">Kılıçlar Suit'inin Anlamı</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-slate-100 mb-2">Pozitif Yönler</h3>
                <ul className="space-y-1 text-slate-300 text-sm">
                  <li>• Keskin zeka ve analitik düşünce</li>
                  <li>• Net iletişim becerisi</li>
                  <li>• Adalet duygusuu ve objektiflik</li>
                  <li>• Problemleri çözme yetisi</li>
                  <li>• Cesaret ve kararlılık</li>
                </ul>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-slate-100 mb-2">Dikkat Edilmesi Gerekenler</h3>
                <ul className="space-y-1 text-slate-300 text-sm">
                  <li>• Aşırı eleştiricilik ve sertlik</li>
                  <li>• Duygusal kopukluk</li>
                  <li>• Gereksiz çatışmalar</li>
                  <li>• Zihinsel stres ve kaygı</li>
                  <li>• Acımasızlık ve soğukluk</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="bg-slate-800 rounded-xl p-6 border border-slate-700">
            <h2 className="text-2xl font-semibold text-slate-100 mb-4">Yaşam Alanlarındaki Etkiler</h2>
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-semibold text-gray-400 mb-2">Zihinsel Süreçler</h3>
                <p className="text-slate-300 text-sm leading-relaxed">
                  Karar verme, analiz, problem çözme ve stratejik planlama süreçleri.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-400 mb-2">İletişim</h3>
                <p className="text-slate-300 text-sm leading-relaxed">
                  Açık konuşma, yazışmalar, tartışmalar ve fikir alışverişi.
                </p>
              </div>
              <div>
                <h3 className="text-lg font-semibold text-gray-400 mb-2">Adalet ve Hukuk</h3>
                <p className="text-slate-300 text-sm leading-relaxed">
                  Yasal süreçler, etik kararlar ve adil çözümler arayışı.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Element Connection */}
        <div className="bg-slate-800 rounded-xl p-6 border border-slate-700 mb-8">
          <h2 className="text-2xl font-semibold text-slate-100 mb-6">Hava Elementi Bağlantısı</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-gray-500 to-slate-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <Sword className="h-8 w-8 text-white" />
              </div>
              <h3 className="font-semibold text-slate-200 mb-2">Keskinlik</h3>
              <p className="text-slate-400 text-sm">Zihinsel berraklık ve keskin analiz</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-slate-500 to-gray-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">🌪️</span>
              </div>
              <h3 className="font-semibold text-slate-200 mb-2">Hareket</h3>
              <p className="text-slate-400 text-sm">Hızlı düşünce ve değişim</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-gray-500 to-slate-700 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-white text-2xl">💭</span>
              </div>
              <h3 className="font-semibold text-slate-200 mb-2">İletişim</h3>
              <p className="text-slate-400 text-sm">Fikir paylaşımı ve diyalog</p>
            </div>
          </div>
        </div>

        {/* Important Note */}
        <div className="bg-amber-900/20 border border-amber-700/50 rounded-xl p-6 mb-8">
          <h3 className="text-lg font-semibold text-amber-200 mb-3">⚠️ Önemli Uyarı</h3>
          <p className="text-amber-100 leading-relaxed">
            Tarot kartları sembolik yorumlama araçlarıdır ve kesinlik iddiası taşımazlar. İçerikler tamamen
            merak, eğlence ve kişisel farkındalık amaçlıdır. Yaşamsal kararlar için uzman görüşü alınmalıdır.
          </p>
        </div>

        {/* Navigation */}
        <div className="flex justify-between items-center">
          <Link
            href="/about/tarot/systems/rider-waite/minor-arcana/cups"
            className="inline-flex items-center px-4 py-2 bg-slate-800 hover:bg-slate-700 border border-slate-600 rounded-lg text-slate-300 hover:text-slate-100 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Kupalar
          </Link>

          <Link
            href="/about/tarot/systems/rider-waite/minor-arcana/pentacles"
            className="inline-flex items-center px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors"
          >
            Pentagramlar
            <ArrowLeft className="h-4 w-4 ml-2 rotate-180" />
          </Link>
        </div>
      </div>
    </AboutLayout>
  );
}